import { memo, type ComponentPropsWithoutRef } from "react";
import Image from "next/image";
import { StaticImport } from "next/dist/shared/lib/get-img-props";

type ImageSource = {
  src: string | StaticImport;
  src2x?: string | StaticImport;
};

type PictureProps = {
  desktop?: ImageSource;
  mobile?: ImageSource;
  width: number;
  height: number;
  alt?: string;
  priority?: boolean;
  quality?: number;
  className?: string;
  classNameImage?: string;
  imageProps?: Omit<
  ComponentPropsWithoutRef<"img">,
  "width" | "height" | "alt" | "src" | "srcSet"
>
} & ComponentPropsWithoutRef<"picture">;

const Picture = ({
  desktop,
  mobile,
  width,
  height,
  alt = "",
  priority = false,
  quality,
  className,
  classNameImage,
  imageProps,
  ...rest
}: PictureProps) => {
  const fallback = desktop ?? mobile;
  if (!fallback) return null;

  return (
    <picture className={className} {...rest}>
      {mobile && (
        <source
          srcSet={`${mobile.src2x ?? mobile.src} 2x, ${mobile.src} 1x`}
          media="(max-width: 767px)"
        />
      )}
      {desktop && (
        <source
          srcSet={`${desktop.src2x ?? desktop.src} 2x, ${desktop.src} 1x`}
          media="(min-width: 768px)"
        />
      )}
      <Image
        src={fallback.src}
        alt={alt}
        width={width}
        height={height}
        priority={priority}
        quality={quality}
        className={classNameImage}
        {...imageProps}
      />
    </picture>
  );
};

export default memo(Picture);
